var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5501 1H3.78313C2.24841 1 1 2.2488 1 3.78351V30.5433C1 32.0776 2.24841 33.326 3.78313 33.326H32.5501C34.0848 33.326 35.3332 32.0776 35.3332 30.5433V3.78351C35.3332 2.2488 34.0848 1 32.5501 1ZM32.4434 30.437H3.88981V10.5811H32.4434V30.437ZM32.4434 7.69052H3.88981V3.8902H32.4434V7.69052ZM30.2899 18.0021H20.0094V28.2827H30.2899V18.0021Z",
    fill: "#BFBFBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0094 18.0021H30.2899V28.2827H20.0094V18.0021Z",
    fill: "#BFBFBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5501 1H3.78313C2.24841 1 1 2.2488 1 3.78351V30.5433C1 32.0776 2.24841 33.326 3.78313 33.326H32.5501C34.0848 33.326 35.3332 32.0776 35.3332 30.5433V3.78351C35.3332 2.2488 34.0848 1 32.5501 1ZM32.4434 30.437H3.88981V10.5811H32.4434V30.437ZM32.4434 7.69052H3.88981V3.8902H32.4434V7.69052ZM30.2899 18.0021H20.0094V28.2827H30.2899V18.0021Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0094 18.0021H30.2899V28.2827H20.0094V18.0021Z",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0093 18.0023H30.2899V28.2829H20.0093V18.0023Z",
    fill: "#F7921E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f7b5b56baa3e34d8a69e2573c217b281.svg";
export { ForwardRef as ReactComponent };